export default __webpack_public_path__ + "e56dbaee512687b409841cd6684e754f.svg";